/**
 * Handles User Requests to Core Applications
 * @param {object} Config requestUrl, headers, body
 *
 * @return {{ response: { data: object }}} Promise { response }
 */

import { Encrypt, Decrypt } from '../../utils';

export default async function CoreRequest(
    config = {
        headers: {},
        requestUrl: '',
        body: {}
    }
) {
    try {
        const url = window.location.href;
        const [, stage, , flag] = url.split('.');
        const encryptedBody = Encrypt(config.body);

        // for testing purposes
        console.log('body payload: ', config.body);
        console.log('request url: ', config.requestUrl);

        const response = await fetch(
            // `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
            //     flag ? '' : '/partners'
            // }/${config.requestUrl}`,
            config.requestUrl,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...config.headers
                },
                // body: config.body
                body: JSON.stringify({ data: encryptedBody })
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const parsedResponse = await response.json();

        const decryptedData = JSON.parse(Decrypt(parsedResponse.data));

        const decryptedResponse = new Response(JSON.parse(decryptedData), {
            headers: { 'Content-Type': 'application/json' },
            status: 200,
            statusText: ''
        });

        // for testing purposes
        console.log('decrypt received data: ', JSON.parse(JSON.parse(decryptedData)));

        return decryptedResponse;
    } catch (error) {
        console.error('CoreRequest api error', error);
        throw error;
    }
}
